export default {
  getChains: state => state.chains,
  getChainsLoading: state => state.chainsLoading,
  getChainsLoaded: state => state.chainsLoaded,
  getChainByKey: state => key => state.chains.find(chain => chain.key === key) || null,
}
